export default __webpack_public_path__ + "static/1-c21247d56e653ddf50f6d223f378db21.jpeg";